(function () {
  function getValue(trigger, name) {
    return trigger.getAttribute(name) || '';
  }

  function getWidth(trigger) {
    var width = parseInt(getValue(trigger, 'data-ge-tally-width'), 10);
    return Number.isFinite(width) && width > 0 ? width : 720;
  }

  function buildHiddenFields(trigger) {
    var hiddenFields = {
      originPage: getValue(trigger, 'data-ge-origin-page') || window.location.pathname,
      entryModule: getValue(trigger, 'data-ge-entry-module'),
      starterChoice: getValue(trigger, 'data-ge-starter-choice')
    };

    var collectionHandle = getValue(trigger, 'data-ge-collection-handle');
    var collectionTitle = getValue(trigger, 'data-ge-collection-title');

    if (collectionHandle) hiddenFields.collectionHandle = collectionHandle;
    if (collectionTitle) hiddenFields.collectionTitle = collectionTitle;

    return hiddenFields;
  }

  function openTallyPopup(trigger) {
    var formId = getValue(trigger, 'data-ge-tally-open');
    if (!formId || !window.Tally || typeof window.Tally.openPopup !== 'function') return false;

    window.Tally.openPopup(formId, {
      layout: 'modal',
      width: getWidth(trigger),
      overlay: true,
      hiddenFields: buildHiddenFields(trigger)
    });

    return true;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ge-tally-open]');
    if (!trigger) return;

    if (openTallyPopup(trigger)) {
      event.preventDefault();
    }
  });
})();
